import React from 'react';
import PhonicsReview from './phonics/PhonicsReview';
import letterDataAaNN from './phonics/phonics_data_aa_nn';

function PhonicsAaNN() {
  return <PhonicsReview data={letterDataAaNN} />;
}

export default PhonicsAaNN;
